import type { Input, Output } from '@iichi/schema-api-v2/endpoints/public/search/suggestions';

import axios from '@/js/lib/helper/axios';

export const get = async (params: Input, signal?: AbortSignal): Promise<Output> => {
  const res = await axios.get<Output>('/api/v2/public/search/suggestions', { params, signal });
  return res.data;
};
